import React, {useEffect, useState} from "react";
import {
    IonPage,
    IonContent, IonLoading, IonIcon, IonRefresher, IonRefresherContent
} from "@ionic/react";
import AddJobFormModal from "../components/AddJobFormModal";
import AddJobCandidateProfileModal from "../components/AddJobCandidateProfileModal";
import {addCircle} from "ionicons/icons";
import {
    actionToGetJobDataById,
    actionToGetOtherUsersJobPostData, actionToGetOtherUsersJobProfileData,
    actionToGetUserJobPostData,
    actionToGetUserJobProfileData
} from "../apiHelpers/CommonAction";
import useStore from "../zustand/useStore";
import {FacebookLoader} from "../components/Loader/FacebookLoader";
import JobCard from "../components/JobCard";
import JobDetailsSheetPopup from "../components/JobDetailsSheetPopup";
import JobPortalCandidateRoleComponentMobile from "../components/JobPortalCandidateRoleComponentMobile";
import {useParams} from "react-router";
import JobMembersToApplyComponents from "../components/JobMembersToApplyComponents";
import JobProfileCard from "../components/JobProfileCard";

export default function JobPortalMobileDashboard({renderHeaderPage}) {
    const [addJobModalSheet,setAddJobModalSheet] = useState(false);
    const [addJobProfileModalSheet,setAddJobProfileModalSheet] = useState(false);
    const [isOpenMainJobListPanel,setIsOpenMainJobListPanel] = useState(false);
    const [selectedJobListUserType,setSelectedJobListUserType] = useState(1);
    const [myJobPostsData,setMyJobPostsData] = useState(false);
    const [isLoading,setIsLoading] = useState(false);
    const {
        userJobProfileData, userJobPostData, otherUsersJobPostData, setJobDetailsData, setIsJobDetailOpen,
        isJobDetailOpen,jobDetailsData,otherUsersJobProfileData,setDeservingCandidatesProfileData,isOpenCandidatesDeservingModel, setIsOpenCandidatesDeservingModel
    }= useStore();
    const {id} = useParams();



    useEffect(()=>{
        if(id) {
            actionToGetJobDataById(id).then((jobDetail)=>{
                if(jobDetail?.id) {
                    setJobDetailsData(jobDetail);
                    setIsJobDetailOpen(true);
                }
            });
            setTimeout(()=>{
                window.history.pushState({},null,`${window.location.origin}/dashboard/job-portal`);
            },1000)
        }
    },[id])


    const callFunctionToSelectJobPortalRole = (role)=>{
        setMyJobPostsData(true);
        if(role === 1){
            setAddJobModalSheet(true);
        }else{
            setAddJobProfileModalSheet(true);
        }
    }

    const openJobDetailPanel = (jobDetail)=>{
        setJobDetailsData(jobDetail);
        setIsJobDetailOpen(true);
    }

    const openMainJobListPanel = (myPosts,userType)=>{
        setMyJobPostsData(myPosts);
        setIsOpenMainJobListPanel(true);
        setSelectedJobListUserType(userType);
    }

    useEffect(() => {
        actionToGetUserJobProfileData();
        actionToGetUserJobPostData();
        actionToGetOtherUsersJobPostData();
        actionToGetOtherUsersJobProfileData();
    }, []);

    const handleRefresh = (event) => {
        actionToGetUserJobProfileData();
        actionToGetUserJobPostData();
        actionToGetOtherUsersJobPostData();
        actionToGetOtherUsersJobProfileData();
        setTimeout(() => {
            event.detail.complete();
        }, 2000);
    };

    const openJobCandidateProfileDetail = (jobProfile)=>{
        setIsOpenCandidatesDeservingModel(true);
        setDeservingCandidatesProfileData({...jobProfile});
    }


    return (
        <IonPage>
            {renderHeaderPage && renderHeaderPage()}
            <IonContent fullscreen className="looking-for-page page-content">
                <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                    <IonRefresherContent pullingText="Pull to refresh" refreshingSpinner="circles"/>
                </IonRefresher>
                <div className={"main_inner_container_common_page mobile_inner_dashboard_page job_mob_d"}>
                    {/*//////////// my cv section //////////*/}
                    {(userJobProfileData?.loading) ?
                        <div className={"verticel_scroll_container_outer"}>
                            <div className={"h_in_v_card"}>
                                <div className={"in_heading"}>
                                    My Job Profile
                                </div>
                            </div>
                            <div className={"verticel_scroll_container_inner"}>
                                <div className="job-card my-job-profile">
                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                </div>
                            </div>
                        </div>
                        :(userJobProfileData?.jobProfileData?.id) ?
                            <div className={"verticel_scroll_container_outer"}>
                                <div className={"h_in_v_card"}>
                                    <div className={"in_heading"}>
                                        My Job Profile
                                    </div>
                                    <div onClick={() => callFunctionToSelectJobPortalRole(2)} className={"view_all_action_button"}>
                                        Edit
                                    </div>
                                </div>
                                <div className={"verticel_scroll_container_inner"}>
                                    <JobProfileCard
                                        myProfile={true}
                                        openJobCandidateProfileDetail={openJobCandidateProfileDetail}
                                        jobProfileData={userJobProfileData?.jobProfileData}
                                    />
                                </div>
                            </div>
                            :
                            <div className={"verticel_scroll_container_outer"}>
                                <div className={"h_in_v_card"}>
                                    <div className={"in_heading"}>
                                        My Job Profile
                                    </div>
                                </div>
                                <div className={"verticel_scroll_container_inner"}>
                                    <div className={"no_data_found_add_new_data job-card my-job-profile"}>
                                        <div onClick={() => callFunctionToSelectJobPortalRole(2)} className={"add_data_button_n_v_Data"}>
                                            <IonIcon icon={addCircle}/>
                                            Upload CV
                                        </div>
                                        <div className={"message_no_j_d_but"}>
                                            No CV Uploaded Yet!
                                        </div>
                                    </div>
                                </div>
                            </div>
                    }
                    {/*//////////// my cv section //////////*/}

                    {(userJobPostData?.loading) ?
                        <div className={"verticel_scroll_container_outer"}>
                            <div className={"h_in_v_card"}>
                                <div className={"in_heading"}>
                                    My Job Posts
                                </div>
                            </div>
                            <div className={"verticel_scroll_container_inner"}>
                                <div className="job-card">
                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                </div>
                                <div className="job-card">
                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                </div>
                            </div>
                        </div>
                        :(userJobPostData?.jobPostData?.length) ?
                            <div className={"verticel_scroll_container_outer"}>
                                <div className={"h_in_v_card"}>
                                    <div className={"in_heading"}>
                                        My Job Posts
                                        {(userJobPostData?.jobPostData?.length) && (
                                            <div onClick={() => callFunctionToSelectJobPortalRole(1)} className={"add_more"}>
                                                <IonIcon icon={addCircle}/>
                                                Add More
                                            </div>
                                        )}
                                    </div>
                                    <div onClick={()=>openMainJobListPanel(true,2)} className={"view_all_action_button"}>
                                        View All
                                    </div>
                                </div>
                                <div className={"verticel_scroll_container_inner"}>
                                    {(userJobPostData?.jobPostData?.map((job)=>(
                                        <JobCard
                                            job={job}
                                            myJobPostsData={true}
                                            key={job.id}
                                            handleJobItemClick={openJobDetailPanel}
                                        />
                                    )))}
                                </div>
                            </div>
                            :
                            <div className={"verticel_scroll_container_outer"}>
                                <div className={"h_in_v_card"}>
                                    <div className={"in_heading"}>
                                        My Job Posts
                                    </div>
                                </div>
                                <div className={"verticel_scroll_container_inner"}>
                                    <div className={"no_data_found_add_new_data job-card my-job-profile"}>
                                        <div onClick={() => callFunctionToSelectJobPortalRole(1)} className={"add_data_button_n_v_Data"}>
                                            <IonIcon icon={addCircle}/>
                                            Add Job
                                        </div>
                                        <div className={"message_no_j_d_but"}>
                                            No Job Posted Yet!
                                        </div>
                                    </div>
                                </div>
                            </div>
                    }

                    <hr/>

                    {/*///////////// ALL POST DATA //////////////////*/}
                    {(otherUsersJobPostData?.loading) ?
                        <div className={"verticel_scroll_container_outer"}>
                            <div className={"h_in_v_card"}>
                                <div className={"in_heading"}>
                                    Other Job Posts
                                </div>
                            </div>
                            <div className={"verticel_scroll_container_inner"}>
                                <div className="job-card">
                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                </div>
                                <div className="job-card">
                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                </div>
                            </div>
                        </div>
                        :(otherUsersJobPostData?.jobPostData?.length) ?
                            <div className={"verticel_scroll_container_outer"}>
                                <div className={"h_in_v_card"}>
                                    <div className={"in_heading"}>
                                        Other Job Posts
                                    </div>
                                    <div onClick={()=>openMainJobListPanel(false,1)} className={"view_all_action_button"}>
                                        View All
                                    </div>
                                </div>
                                <div className={"verticel_scroll_container_inner"}>
                                    {(otherUsersJobPostData?.jobPostData?.map((job)=>(
                                        <JobCard
                                            job={job}
                                            key={job.id}
                                            handleJobItemClick={openJobDetailPanel}
                                        />
                                    )))}
                                </div>
                            </div>
                            :
                            <div className={"verticel_scroll_container_outer"}>
                                <div className={"h_in_v_card"}>
                                    <div className={"in_heading"}>
                                        Other Job Posts
                                    </div>
                                </div>
                                <div className={"verticel_scroll_container_inner"}>
                                    <div className={"no_data_found_add_new_data job-card my-job-profile"}>
                                        <div className={"message_no_j_d_but"}>
                                            No Job Posted Yet!
                                        </div>
                                    </div>
                                </div>
                            </div>
                    }
                    {/*///////////// ALL POST DATA //////////////////*/}

                    {/*///////////// ALL POST DATA //////////////////*/}
                    {(otherUsersJobProfileData?.loading) ?
                        <div className={"verticel_scroll_container_outer"}>
                            <div className={"h_in_v_card"}>
                                <div className={"in_heading"}>
                                    Other Candidate Profiles
                                </div>
                            </div>
                            <div className={"verticel_scroll_container_inner"}>
                                <div className="job-card">
                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                </div>
                                <div className="job-card">
                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                </div>
                            </div>
                        </div>
                        :(otherUsersJobProfileData?.jobProfileData?.length) ?
                            <div className={"verticel_scroll_container_outer"}>
                                <div className={"h_in_v_card"}>
                                    <div className={"in_heading"}>
                                        Other Candidate Profiles
                                    </div>
                                    <div onClick={()=>openMainJobListPanel(false,2)} className={"view_all_action_button"}>
                                        View All
                                    </div>
                                </div>
                                <div className={"verticel_scroll_container_inner"}>
                                    {(otherUsersJobProfileData?.jobProfileData?.map((jobProfileData)=>(
                                        <JobProfileCard
                                            key={jobProfileData?.id}
                                            jobProfileData={jobProfileData}
                                            openJobCandidateProfileDetail={openJobCandidateProfileDetail}
                                        />
                                    )))}
                                </div>
                            </div>
                            :
                            <div className={"verticel_scroll_container_outer"}>
                                <div className={"h_in_v_card"}>
                                    <div className={"in_heading"}>
                                        Other Candidate Profiles
                                    </div>
                                </div>
                                <div className={"verticel_scroll_container_inner"}>
                                    <div className={"no_data_found_add_new_data job-card my-job-profile"}>
                                        <div className={"message_no_j_d_but"}>
                                            No Job Posted Yet!
                                        </div>
                                    </div>
                                </div>
                            </div>
                    }
                    {/*///////////// ALL POST DATA //////////////////*/}
                </div>
            </IonContent>

            {/*/////// JOB POSTING //////////////*/}
            {(addJobModalSheet) ?
            <AddJobFormModal isOpen={addJobModalSheet}
                             fromJobList={true}
                             myJobPostsData={myJobPostsData}
                             onClose={() => setAddJobModalSheet(false)}
                             setIsLoading={setIsLoading}/>:''
            }
            {/*/////// JOB POSTING //////////////*/}

            {/*/////// JOB CANDIDATE PROFILE //////////////*/}
            {(addJobProfileModalSheet) ?
            <AddJobCandidateProfileModal isOpen={addJobProfileModalSheet}
                                         onClose={() => setAddJobProfileModalSheet(false)}
                                         setIsLoading={setIsLoading}
                                         selectedUserType={2}
                                         dataForEditing={userJobProfileData?.jobProfileData}/>
                :''
            }
            {/*/////// JOB CANDIDATE PROFILE //////////////*/}

            <IonLoading isOpen={isLoading} className={"loading_loader_spinner_container"} message={"Please Wait..."}/>


            {(isJobDetailOpen) ?
            <JobDetailsSheetPopup isOpen={isJobDetailOpen}
                                  jobDetailsData={jobDetailsData}
                                  onDidDismiss={() => setIsJobDetailOpen(false)}/>:''
            }

            {(isOpenMainJobListPanel) ?
            <JobPortalCandidateRoleComponentMobile
                isOpen={isOpenMainJobListPanel}
                selectedJobListUserType={selectedJobListUserType}
                myJobPostsData={myJobPostsData}
                onDidDismiss={() => setIsOpenMainJobListPanel(false)}
              />:''
            }

            {/*/////// JOB CANDIDATES DESERVING //////////////*/}
            {(isOpenCandidatesDeservingModel) ?
                <JobMembersToApplyComponents isOpen={isOpenCandidatesDeservingModel} />
                :''
            }
            {/*/////// JOB CANDIDATES DESERVING //////////////*/}
        </IonPage>
    )
}
